import { useProcessingDataExportDocument } from 'src/suitability-report/hooks/useProcessingDataExportDocument';
import { BackgroundProcess, FileData } from 'src/data-capture/hooks/file-uploads/types';
import { useMemo } from 'react';

type MeetingAgenda = {
  id: string;
  clientId: string;
  templateId?: string;
  createdAt: string;
  backgroundProcessId?: string;
  backgroundProcess?: BackgroundProcess;
  fileId?: number;
  fileName?: string;
  file?: FileData;
  isGenerated: true;
};

type Props = {
  clientId?: string;
};

export const useMeetingAgenda = ({ clientId }: Props = {}) => {
  const { items, isLoading, isError, error, refetch } = useProcessingDataExportDocument<
    Omit<MeetingAgenda, 'isGenerated'>
  >({
    clientId,
    resource: 'meeting-agendas',
  });

  const meetingAgendas = useMemo(
    () => items.map(agenda => ({ ...agenda, isGenerated: true })),
    [items],
  );

  return {
    meetingAgendas,
    isLoading,
    isError,
    error,
    refetch,
  };
};
